import styled from 'styled-components';

const MapStyle = styled.div`
  height: 80vh;
  width: 100%;
  margin-top: 24px;
  margin-left: 0px;
  margin-bottom: 24px;
  display: block;
`

export default MapStyle;
